(function(w){'use strict';
var NAME_MAX=15,DRINK_COUNT=12;
var L={
 bg:['Cream','Blush','Rose','Lilac','Periwinkle','Sky','Mint','Sage'],
 quote:['Just A Woman Who Loves Wine','Corks Are For Quitters','Just A Girl Who Loves Wine','Sips About To Go Down'],
 age:['Young Woman','Aged Woman'],
 skin:['Light','Fair','Tan','Deep'],
 eyes:['Amber','Black','Blue','Brown','Green','Grey','Hazel'],
 glasses:['No Glasses','Cat Eyes Glasses','Sunglasses','Square Glasses','Circle Glasses'],
 hairColor:['Black','Golden Blonde','Platinum','Dark Brown','Silver Grey','Auburn','Ginger','Pink','Purple','Navy','Charcoal'],
 hairYoung:['Bald','Long Waves','High Ponytail','Messy Bun','Sleek Bob','Side Braid','Big Curls','Pigtails','Long Straight','Half Up Waves','Pixie Cut','Afro Curls','Side Ponytail',
  'Top Knot','Long Layers','Shoulder Lob','Box Braids','Space Buns','Low Ponytail',
  'Shoulder Ringlets','Crown Braid','Asymmetric Bob','Beach Waves','Curly Bob','Dutch Braids',
  'High Bun Bangs','Shag Cut','Long Wavy','Afro Puff','Volume Ponytail','Fishtail Braid',
  'Blunt Bob','Feathered','Messy Low Bun','Sleek Ponytail','Pixie Curls','Half Up Buns',
  'Wavy Bob','Braided Ponytail','Twisted Side Bun','Big Curly','Side Bangs','Bubble Ponytail',
  'Tucked Bob','Braided Pigtails','Waves And Bangs','Curly Top Knot','Flipped Layers','Shoulder Locs'],
 hairAged:['Bald','Short Perm','Low Chignon','Wavy Bob','Pixie Sweep','Soft Waves','Braided Updo'],
 acc:['No','Bow','Christmas Tree','Hat','Reindeer','Leopard Turban','Red Turban'],
 clothes:['Sweater','T Shirt','Tank Top','Xmas Sweater'],
 sweater:['Black','Blue','Green','Grey','Leopard','Pink','Red','White','Yellow'],
 drinkType:['Beer','Cocktail','Coffee, Tea And Cocoa','Fruit Juice And Smoothie','Liquor And Spirit','Soft Drink','Wine']
};
// [selection key, cart property, list in L] - null list = depends on another field (hair -> age, drink -> drinkType), see options()
var KEYS=[['bg','Background Color','bg'],['quote','Quote','quote'],['age','Age Range','age'],['skin','Skin Tone','skin'],['eyes','Eyes Color','eyes'],['glasses','Glasses','glasses'],['hairColor','Hair Color','hairColor'],['hair','Hairstyle',null],['acc','Accessories','acc'],['clothes','Clothes','clothes'],['sweater','Sweater Color','sweater'],['drinkType','Drink','drinkType'],['drink','Drink Choice',null]];
function clean(s){return String(s==null?'':s).replace(/\s+/g,' ').trim();}
function hairList(age){return age==='Aged Woman'?L.hairAged:L.hairYoung;}
// items of a drink category (name or index): 'Wine' -> ['Wine 1',...,'Wine 12']
function drinkList(type){
 var t=typeof type==='number'?L.drinkType[type]:type,out=[],i;if(L.drinkType.indexOf(t)<0)return out;
 for(i=1;i<=DRINK_COUNT;i++)out.push(t+' '+i);
 return out;
}
function options(key,s){s=s||{};return key==='hair'?hairList(s.age):key==='drink'?drinkList(s.drinkType):L[key]||[];}
// s = {bg:'Cream',quote:'...',age:'Young Woman',skin:'Light',...,hair:'Long Waves',acc:'No',clothes:'Sweater',sweater:'Red',drinkType:'Wine',drink:'Wine 1',name:'Almira'}
function missing(s){
 var m=[];
 KEYS.forEach(function(k){var list=k[2]?L[k[2]]:options(k[0],s);if(list.indexOf(s[k[0]])<0)m.push(k[0]);});
 if(!clean(s.name))m.push('name');
 return m;
}
function props(s){
 if(missing(s).length)throw Error('Please complete your personalization.');
 var p={};
 KEYS.forEach(function(k){p[k[1]]=s[k[0]];});
 var n=clean(s.name);if(n.length>NAME_MAX)throw Error('Custom Name is limited to '+NAME_MAX+' characters.');
 p['Custom Name']=n;return p;
}
function apply(payload,s,ids){
 var items=(payload.items||[payload]).map(function(i){return Object.assign({},i);}),p=props(s);
 items.forEach(function(i){if(ids.indexOf(String(i.id))>=0)i.properties=Object.assign({},i.properties,p);});
 var out=payload.items?Object.assign({},payload):{};out.items=items;return out;
}
w.CWCore={NAME_MAX:NAME_MAX,DRINK_COUNT:DRINK_COUNT,L:L,KEYS:KEYS,clean:clean,hairList:hairList,drinkList:drinkList,options:options,missing:missing,props:props,apply:apply};
})(typeof window==='undefined'?globalThis:window);
